export default __webpack_public_path__ + "static/media/SourceSansPro-Bold.7edc663e.ttf";